var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"modal-lots","size":"lg","title":"Lotes procesados"},on:{"show":function($event){return _vm.getLot(_vm.process_id)}}},[_c('b-table',{attrs:{"striped":"","small":"","hover":"","items":_vm.items,"fields":_vm.fields}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }